import BankCard from './bank-card/index.vue'
import BankCardList from './bank-card-list/index.vue'
import CreditDepositCardList from './credit-deposit-card-list/index.vue'
import InsuranceCardList from './insurance-card-list/index.vue'
import ServiceCardList from './service-card-list/index.vue'
import CurrencyRateList from './currency-rate-list/index.vue'
import MoneyTransfers from './money-transfers/index.vue'
import PageTextBlock from './page-text-block/index.vue'
import TextBlock from './text-block/index.vue'
import AnyQuestions from './any-questions/index.vue'
import AppMobileBlock from './app-mobile-block/index.vue'
import FaqItem from './faq-item/index.vue'
import FaqItems from './faq-items/index.vue'
import ModalButton from './modal-button/index.vue'
import DocumentItem from './document-item/index.vue'
import DocumentsList from './documents-list/index.vue'
import Paragraph from './paragraph/index.vue'
import InfoTooltip from './info-tooltip/index.vue'
import InfoTooltipList from './info-tooltip-list/index.vue'
import TransferService from './transfer-service/index.vue'
import TransferServiceList from './transfer-service-list/index.vue'
import PageInformationButton from './page-information-button/index.vue'
import Memo from './memo/index.vue'
import InfoBalloon from './info-balloon/index.vue'
import InfoBalloons from './info-balloons/index.vue'
import PageMimiTextBlocks from './page-mimi-text-blocks/index.vue'
import PageMimiTextBlock from './page-mimi-text-block/index.vue'
import StepBoxList from './step-box-list/index.vue'
import LinkTooltip from './link-tooltip/index.vue'
import TableComponent from './table/index.vue'
import HowToGetProduct from './how-to-get-product/index.vue'
import ZoomImage from './zoom-image/index.vue'
import ZoomImageList from './zoom-image-list/index.vue'
import ManualItem from './manual-item/index.vue'
import ManualItemList from './manual-item-list/index.vue'
import LinkButton from './link-button/index.vue'
import CashBlock from './contacts/cash/cash-block/index.vue'
import OfficeBlock from './contacts/office/office-block/index.vue'
import Carousel from './carousel/index.vue'
import CurrenciesMap from './currencies-map/index.vue'
import InfoShowcase from './info-showcase/index.vue'
import CallBlock from './call-block/call-block.vue'
import CallBlockList from './call-block-list/call-block-list.vue'
import CityCard from './city-card/index.vue'
import BankHistoryBlock from './bank-history-block/bank-history-block.vue'
import BankHistoryBlockList from './bank-history-block-list/bank-history-block-list.vue'
import CalculatorBlock from './calculator-block/index.vue'
import CalculatorList from './calculator-list/index.vue'
import DepositsBlock from './deposits-block/deposits-block.vue'
import PunktListBlock from './punkt-list-block/punkt-list-block.vue'
import Editor from './editor/index.vue'
import CarouselStandard from './carousel-standard/index.vue'
import Banner from './banner/index.vue'
import Reference from './reference/index.vue'
import YellowBg from './yellow-bg/index.vue'
import ServiceCardTable from './service-card-table/index.vue'
import BgImgBtnBlock from './bg-img-btn-block/index.vue'
import BgImgBtnTable from './bg-img-btn-table/index.vue'
import LinkBlock from './link-block/index.vue'
import InfoSquare from './info-square/index.vue'
import InfoSquareList from './info-square-list/index.vue'
import p2p from './p2p/index.vue'
import TextWithTriggerModal from './text-with-trigger-modal/index.vue'
import ListOfItemsWithADot from './list-of-items-with-a-dot/index.vue'
import ListOfPaymentLimit from './list-of-payment-limit/index.vue'
import VideoBlock from './video-block/index.vue'
import MainMap from './contacts/main-map/index.vue'
import WorkSchedule from './work-schedule/index.vue'
import CartPoint from './cart-point/index.vue'
import CartPointList from './cart-point-list/index.vue'

const StaticBlocks = {
  BankCard,
  BankCardList,
  CreditDepositCardList,
  InsuranceCardList,
  ServiceCardList,
  CurrencyRateList,
  MoneyTransfers,
  PageTextBlock,
  TextBlock,
  AnyQuestions,
  AppMobileBlock,
  FaqItem,
  FaqItems,
  ModalButton,
  DocumentItem,
  DocumentsList,
  Paragraph,
  InfoTooltip,
  InfoTooltipList,
  TransferService,
  TransferServiceList,
  PageInformationButton,
  Memo,
  InfoBalloon,
  InfoBalloons,
  PageMimiTextBlocks,
  PageMimiTextBlock,
  StepBoxList,
  LinkTooltip,
  TableComponent,
  HowToGetProduct,
  ZoomImage,
  ZoomImageList,
  ManualItem,
  ManualItemList,
  LinkButton,
  CashBlock,
  OfficeBlock,
  Carousel,
  CurrenciesMap,
  InfoShowcase,
  CallBlock,
  CallBlockList,
  CityCard,
  BankHistoryBlock,
  BankHistoryBlockList,
  CalculatorBlock,
  CalculatorList,
  DepositsBlock,
  PunktListBlock,
  Editor,
  CarouselStandard,
  Banner,
  Reference,
  YellowBg,
  ServiceCardTable,
  BgImgBtnBlock,
  BgImgBtnTable,
  LinkBlock,
  InfoSquare,
  InfoSquareList,
  p2p,
  TextWithTriggerModal,
  ListOfItemsWithADot,
  ListOfPaymentLimit,
  VideoBlock,
  MainMap,
  WorkSchedule,
  CartPoint,
  CartPointList
}

export {
  BankCard,
  BankCardList,
  CreditDepositCardList,
  InsuranceCardList,
  ServiceCardList,
  CurrencyRateList,
  MoneyTransfers,
  PageTextBlock,
  TextBlock,
  AnyQuestions,
  AppMobileBlock,
  FaqItem,
  FaqItems,
  ModalButton,
  DocumentItem,
  DocumentsList,
  Paragraph,
  InfoTooltip,
  InfoTooltipList,
  TransferService,
  TransferServiceList,
  PageInformationButton,
  Memo,
  InfoBalloon,
  InfoBalloons,
  PageMimiTextBlocks,
  PageMimiTextBlock,
  StepBoxList,
  LinkTooltip,
  TableComponent,
  HowToGetProduct,
  ZoomImage,
  ZoomImageList,
  ManualItem,
  ManualItemList,
  LinkButton,
  CashBlock,
  OfficeBlock,
  Carousel,
  CurrenciesMap,
  InfoShowcase,
  CallBlock,
  CallBlockList,
  CityCard,
  BankHistoryBlock,
  BankHistoryBlockList,
  CalculatorBlock,
  CalculatorList,
  DepositsBlock,
  PunktListBlock,
  Editor,
  CarouselStandard,
  Banner,
  Reference,
  YellowBg,
  ServiceCardTable,
  BgImgBtnBlock,
  BgImgBtnTable,
  LinkBlock,
  InfoSquare,
  InfoSquareList,
  p2p,
  TextWithTriggerModal,
  ListOfItemsWithADot,
  ListOfPaymentLimit,
  VideoBlock,
  MainMap,
  WorkSchedule,
  CartPoint,
  CartPointList
}

export declare namespace Static {
  type TemplateCodes =
    | 'bank-card'
    | 'bank-card-list'
    | 'insurance-card'
    | 'insurance-card-list'
    | 'credit-deposit-card'
    | 'credit-deposit-card-list'
    | 'page-information-button'
    | 'service-card-list'
    | 'service-card'
    | 'paragraph'
    | 'info-tooltip'
    | 'info-tooltip-list'
    | 'info-balloon'
    | 'info-balloons'
    | 'transfer-service-list'
    | 'zoom-image'
    | 'zoom-image-list'
    | 'manual-item'
    | 'manual-item-list'
    | 'cash-block'
    | 'office-block'
    | 'main-map'
    | 'carousel'
    | 'call-block'
    | 'call-block-list'
    | 'city-card'
    | 'bank-history-block'
    | 'bank-history-block-list'
    | 'transfer-service'
    | 'transfer-service-list'
    | 'deposits-block'
    | 'punkt-list-block'
    | 'document-item'
    | 'editor'
    | 'faq-item'
    | 'carousel-standard'
    | 'banner'
    | 'yellow-bg'
    | 'service-card-table'
    | 'bg-img-btn-block'
    | 'bg-img-btn-table'
    | 'link-block'
    | 'info-square'
    | 'info-square-list'
    | 'p2p'
    | 'text-with-trigger-modal'
    | 'list-of-items-with-a-dot'
    | 'list-of-payment-limit'
    | 'video-block'
    | 'work-schedule';

  export interface StaticFile {
    /**
     * * id файла
     */
    id: number;
    /**
     * * url для скачивания
     */
    url: string;
    /**
     * * Наименование файла
     */
    name: string;
  }

  export interface StaticBlockField {
    code: string;
    type: string;
    value: any;
  }

  export interface StaticBlock {
    fields: StaticBlockField[];
    sort: number;
    templateId: number;
  }

  /**
   * * Данные статики
   */
  export interface Static {
    /**
     * * Код ресурса
     */
    code: string;
    /**
     * * Файл статики
     */
    file: StaticFile | null;
    /**
     * * id статики
     */
    id: number;
    /**
     * * Страница статики
     */
    page: number;
    /**
     * * id родительской страницы
     */
    parentId: number | null;
    /**
     * * Список доступных сайтов
     */
    siteId: number[] | null;
    /**
     * * Уровень сортировки
     */
    sort: number | null;
    /**
     * * Описание статики
     */
    text: string;
    /**
     * * Заголовок статики
     */
    title: string;
    /**
     * * Массив рекурсивной вложенности статических ресурсов
     */
    items: Array<Static>;
    /**
     * Поля страницы
     */
    fields?: {
      mainFields?: StaticBlockField[];
      block?: StaticBlock[];
    };

    params: {
      [key: string]: any;
      innerTemplateCode?: TemplateCodes;
      templateCode: TemplateCodes;
      useBlocksFilters?: boolean;
      blocksLimit?: boolean;
      useShowMore?: boolean;
      useHeader?: boolean;
      useBackgroundColor?: string;
      useContainer?: boolean;
      paddingTop?: number;
      paddingBottom?: number;
      isHorizontal?: boolean;
      blockPerRow?: number;
      reverse?: boolean;
      showMoreLink?: boolean;
      useWhiteShowMoreLinkColor?: boolean
    };
  }

  /**
   * * Данные изображения
   */
  export interface StaticImage {
    /**
     * * Ссылка на изображение
     */
    src: string;

    /**
     * * Ссылка на эскиз изображения
     */
    thumb: string;

    /**
     * * Тип
     */
    type: string;
  }
}

export default StaticBlocks
